export default __webpack_public_path__ + "static/media/04.12318e63.jpg";